import React from 'react'
import Button from '../../atoms/button/button'
import DiamondButton from '../../atoms/diamond-button/diamond-button'

import imgEscenarios from '../../../assets/images/home-section/escenarios_home.png'
import logoHome from '../../../assets/images/home-section/logo_home.png'
import logoHomeMb from '../../../assets/images/home-section/logo_home_mb.png'
import imgNinaBuscadora from '../../../assets/images/home-section/nina_busca.png'
import { pushEventData } from '../../../utils/pushEventDataLayer'
import './home-content.scss'
import { navigate } from 'gatsby'
import Show from '../../../utils/show'

import premioProductImg from '../../../utils/premiosImg'


const LOCALE = ['es-EC', 'es-BO', 'es-PE', 'es-AR', 'es-DO', 'es-PY'].indexOf(process.env.LOCALE) > -1 ? process.env.LOCALE : 'default';

const HomeContent = ({ isMobile }) => {

  const italatam = LOCALE === 'es-AR' || LOCALE === 'es-PY';
  const goToGame = () => {
    pushEventData(
      {
        event: 'Quiero jugar',
        action: 'click juego',
        label: 'Quiero Jugar'
      }
    );
    navigate("/game");
  }
  return (
    <div id="inicio" className="f-home-content-container">
      <div className="f-home-content-container__wrapper">
        <section className="f-home-content-container__section1">
          {isMobile && (
            <img
              src={logoHomeMb}
              alt="titulo de la actividad de nostras online"
              className="f-home-content-container__section1__imgLogoMobile"
            />
          )}
          <img
            src={imgEscenarios}
            alt="escenarios donde jugaran las usuarias"
          />
          <div className="f-home-content-container__section1__boxInfo">

            <p>
              <b>Es hora de divertirte,</b> mientras {italatam ? 'aprendés' : 'aprendes'} sobre la rutina
              perfecta para <b>tu Zona V</b>
            </p>

            <h3>¡En este juego el tiempo es oro!</h3>
          </div>
        </section>
        <section className="f-home-content-container__section2">
          {!isMobile && (
            <img
              src={logoHome}
              alt="titulo de la actividad de nostras online"
            />
          )}
          <h2>¿Lista para jugar?</h2>
          <Button onClick={goToGame}>Quiero jugar</Button>
          <DiamondButton
            className="f-mb30 --small --colorPurple"
            onClick={() => {
              navigate("#participate")
            }}
          />
        </section>
        <section className="f-home-content-container__section3">
          <img
            src={imgNinaBuscadora}
            alt="usuaria buscando las palabras de la actividad"
            className="f-home-content-container__section3__imgBuscadora"
          />
          <div className="f-home-content-container__section3__boxPink">
            <p>
              <Show valid={!italatam}> <b>Consigue la máxima puntuación, </b> encuentra las palabras
                escondidas, <b>¡y que nada te detenga!</b>
              </Show>
              <Show valid={italatam}>
                <b> Conseguí la máxima puntuación, </b>encontrá las palabras escondidas,<b> ¡y que nada te detenga!</b>
              </Show>
            </p>
          </div>
          <div className="f-home-content-container__section3__boxPremios">
            <div className={'f-home-content-container__section3__boxPremios__wrapper   --custom-' + LOCALE}>
              <figure className='f-home-content-container__section3__boxPremios__imgpremio' >
                <img
                  src={premioProductImg}
                  alt="premios para las ganadoras de la actividad"
                />
                <span>*Imagenes de Referencia</span>
              </figure>
              <Show valid={LOCALE === 'default'}>
                <p>
                  Si estás dentro de <b> los mejores 10 puntajes, </b>podrás
                  ganar: <b>Del top 1 al 5: </b> Una waflera para el cabello.<br />
                  <b>Del top 6 al 10: </b>Un kit de productos Nosotras.
                </p>
              </Show>
              <Show valid={LOCALE === 'es-EC'}>
                <p>
                  Si estás <b>dentro de los mejores 10 puntajes</b>, podrás
                  ganar:<br /><b> Del top 1 al 3: </b> Kit de cuidado de la piel + un kit de productos.<br />
                  <b>Del top 4 al 10: </b> Un kit de productos Nosotras.
                </p>
              </Show>
              <Show valid={LOCALE === 'es-PE'}>
                <p>
                  Si estás <b>dentro de los mejores 10 puntajes</b>, podrás
                  ganar:<b> Del top 1 al 5: </b>Un cepillo secador.<br />
                  <b>Del top 6 al 10: </b> Un kit de productos Nosotras.
                </p>
              </Show>
              <Show valid={LOCALE === 'es-BO'}>
                <p>
                  Participa las veces que quieras y gana un paquete de <b>wallpapers diseñados especialmente para ti.</b>
                </p>
              </Show>
              <Show valid={LOCALE === 'es-AR'}>
                <p>
                  Si estás dentro de los <b>mejores 10 puntajes</b>,  podrás ganar una bolsa de tela Nosotras con sorpresas espectaculares.
                </p>
              </Show>
              <Show valid={LOCALE === 'es-DO'}>
                <p>
                  Si estás dentro de los <b>mejores 10 puntajes</b>,  podrás ganar una bolsa de productos Nosotras + merchandising de la marca.
                </p>
              </Show>
              <Show valid={LOCALE === 'es-PY'}>
                <p>
                  Si estás dentro de <b>los mejores 5 puntajes</b>, podrás ganar un espectacular kit de productos + merchandising Nosotras.
                </p>
              </Show>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default HomeContent
